var codeblock_default = {
  "blockStyleSpacing": "_7XoaY",
  "codeBlock": "iR3JB _7XoaY",
  "renderedInTable": "YoYwa"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
